import React, { useState, useEffect } from "react";
import Image from "next/image";
import BonusCard from "./bonusCard/BonusCard";
import CustomCarousel from "../../ui/customCarousel/CustomCarousel";
import styles from "./bonuses.module.scss";
import { useStores } from "../../../hooks/mobx";
import { BonusCardModel } from "./bonusCard/model";
import Link from "next/link";
import rightArrowImg from "../../../new-images/profile/right-to-arrow.svg";
import BlockContainer from "../../mainPageBlocks/blockContainer";

const Bonuses = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1920 },
      items: 5,
      slidesToSlide: 5,
      partialVisibilityGutter: 7,
    },
    desktop: {
      breakpoint: { max: 1919, min: 1440 },
      items: 3,
      slidesToSlide: 3,
      partialVisibilityGutter: 35,
    },
    laptop: {
      breakpoint: { max: 1439, min: 1200 },
      items: 3,
      slidesToSlide: 3,
      partialVisibilityGutter: 3,
    },
    tablet: {
      breakpoint: { max: 1199, min: 768 },
      items: 4,
      slidesToSlide: 4,
      partialVisibilityGutter: 3,
    },
    mobile: {
      breakpoint: { max: 768, min: 360 },
      items: 2,
      slidesToSlide: 2,
      partialVisibilityGutter: -10,
    },
  };
  const [bonuses, setBonuses] = useState([]);
  const [loader, setLoader] = useState(true);
  const { bonusStore, selectedCityStore } = useStores();

  useEffect(() => {
    setLoader(true);
    bonusStore
      .loadBonusesByUrl(`api/profile/bonuses-widget/${selectedCityStore.cityID ? `?city_id=${selectedCityStore.cityID}` : ""}`)
      .then((response) => {
        setBonuses(response.results.map((res) => new BonusCardModel(res)));
        setTimeout(() => {
          setLoader(false);
        }, 500);
      })
      .catch((err) => console.log(err))
  }, []);

  return (
    <div className={styles.Bonuses}>
      <div className={loader ? styles.Show : styles.ShowHidden}></div>
      <div className={!loader ? styles.ContentVisible : styles.Content}>
        <div className={styles.BonusesHead}>
          <h6 className={styles.BlockTitle}>
            {!loader ? "Бонусы донорам" : ""}
          </h6>
          <Link href={"/bonus/?utm_source=profile&utm_medium=bonus&utm_campaign=donor_search"}>
            <a className={styles.BonusesLinkDesktop}>
              {!loader ? "Все бонусы" : ""}
            </a>
          </Link>
          <Link href={"/bonus/"}>
            <div className={styles.BonusLinkAndArrow}>
              <a className={styles.BonusesLink}>
                {!loader ? "Смотреть все" : ""}
              </a>
              <Image src={rightArrowImg} width={28} height={28} />
            </div>
          </Link>
        </div>
        <BlockContainer marginBottom={"0px"} page={"new-lk"}>
          <CustomCarousel
            removeArrowOnDeviceType={["mobile"]}
            swipeable={true}
            draggable={false}
            minimumTouchDrag={70}
            responsive={responsive}
            infinite={false}
            partialVisible={true}
            containerStyle={{ marginLeft: "1px" }}
            className={styles.CaruselBonuses}
          >
            {bonuses.map((bonus) => {
              return (
                <div key={bonus.id} className={styles.Card_Bonus}>
                  <BonusCard
                    showDesktopOnMobile
                    showStatus
                    info={bonus}
                    metricsOnClick={"to_bonus_from_main_page"}
                  />
                </div>
              );
            })}
          </CustomCarousel>
        </BlockContainer>
      </div>
    </div>
  );
};

export default Bonuses;
